import en from './en.json';
import cn from './cn.json';
import tw from './tw.json';
import jp from './jp.json';

import country from './countries.json';
import reverseEngineer from './reverse-engineer.json';

export default {
  en: { ...en, ...country.en, ...reverseEngineer.en },
  cn: { ...cn, ...country.cn, ...reverseEngineer.cn },
  tw: { ...tw, ...country.tw, ...reverseEngineer.tw },
  jp: { ...jp, ...country.jp, ...reverseEngineer.jp },
};
